import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-with-actions.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-with-actions.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
let SearchWithActionsComponent = class SearchWithActionsComponent {
    searchOccurred = new EventEmitter();
    onClickSearchOccurred = new EventEmitter();
    searchPlaceHolder;
    searchDebounce;
    showAdvancedButton;
    showSearchButton;
    constructor() {
    }
    ngOnInit() {
    }
    onClickSearched($event) {
        this.onClickSearchOccurred.emit($event);
    }
    searched($event) {
        this.searchOccurred.emit($event);
    }
    static ctorParameters = () => [];
    static propDecorators = {
        searchOccurred: [{ type: Output }],
        onClickSearchOccurred: [{ type: Output }],
        searchPlaceHolder: [{ type: Input }],
        searchDebounce: [{ type: Input }],
        showAdvancedButton: [{ type: Input }],
        showSearchButton: [{ type: Input }]
    };
};
SearchWithActionsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-with-actions",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], SearchWithActionsComponent);
export { SearchWithActionsComponent };
